/**
 * @fileoverview gRPC-Web generated client stub for seed
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.1
// source: seed.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as seed_pb from './seed_pb'; // proto import: "seed.proto"


export class SeedClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorPredict = new grpcWeb.MethodDescriptor(
    '/seed.Seed/Predict',
    grpcWeb.MethodType.UNARY,
    seed_pb.Request,
    seed_pb.Response,
    (request: seed_pb.Request) => {
      return request.serializeBinary();
    },
    seed_pb.Response.deserializeBinary
  );

  predict(
    request: seed_pb.Request,
    metadata?: grpcWeb.Metadata | null): Promise<seed_pb.Response>;

  predict(
    request: seed_pb.Request,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: seed_pb.Response) => void): grpcWeb.ClientReadableStream<seed_pb.Response>;

  predict(
    request: seed_pb.Request,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: seed_pb.Response) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/seed.Seed/Predict',
        request,
        metadata || {},
        this.methodDescriptorPredict,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/seed.Seed/Predict',
    request,
    metadata || {},
    this.methodDescriptorPredict);
  }

  methodDescriptorPredictAsStream = new grpcWeb.MethodDescriptor(
    '/seed.Seed/PredictAsStream',
    grpcWeb.MethodType.SERVER_STREAMING,
    seed_pb.Request,
    seed_pb.Response,
    (request: seed_pb.Request) => {
      return request.serializeBinary();
    },
    seed_pb.Response.deserializeBinary
  );

  predictAsStream(
    request: seed_pb.Request,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<seed_pb.Response> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/seed.Seed/PredictAsStream',
      request,
      metadata || {},
      this.methodDescriptorPredictAsStream);
  }

  methodDescriptorBulkPredict = new grpcWeb.MethodDescriptor(
    '/seed.Seed/BulkPredict',
    grpcWeb.MethodType.SERVER_STREAMING,
    seed_pb.BulkRequest,
    seed_pb.BulkResponse,
    (request: seed_pb.BulkRequest) => {
      return request.serializeBinary();
    },
    seed_pb.BulkResponse.deserializeBinary
  );

  bulkPredict(
    request: seed_pb.BulkRequest,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<seed_pb.BulkResponse> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/seed.Seed/BulkPredict',
      request,
      metadata || {},
      this.methodDescriptorBulkPredict);
  }

  methodDescriptorProcessVideoFile = new grpcWeb.MethodDescriptor(
    '/seed.Seed/ProcessVideoFile',
    grpcWeb.MethodType.SERVER_STREAMING,
    seed_pb.VideoFileRequest,
    seed_pb.VideoFrameResult,
    (request: seed_pb.VideoFileRequest) => {
      return request.serializeBinary();
    },
    seed_pb.VideoFrameResult.deserializeBinary
  );

  processVideoFile(
    request: seed_pb.VideoFileRequest,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<seed_pb.VideoFrameResult> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/seed.Seed/ProcessVideoFile',
      request,
      metadata || {},
      this.methodDescriptorProcessVideoFile);
  }

  methodDescriptorProcessVideoFileUnary = new grpcWeb.MethodDescriptor(
    '/seed.Seed/ProcessVideoFileUnary',
    grpcWeb.MethodType.UNARY,
    seed_pb.VideoFileRequest,
    seed_pb.VideoFileResult,
    (request: seed_pb.VideoFileRequest) => {
      return request.serializeBinary();
    },
    seed_pb.VideoFileResult.deserializeBinary
  );

  processVideoFileUnary(
    request: seed_pb.VideoFileRequest,
    metadata?: grpcWeb.Metadata | null): Promise<seed_pb.VideoFileResult>;

  processVideoFileUnary(
    request: seed_pb.VideoFileRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: seed_pb.VideoFileResult) => void): grpcWeb.ClientReadableStream<seed_pb.VideoFileResult>;

  processVideoFileUnary(
    request: seed_pb.VideoFileRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: seed_pb.VideoFileResult) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/seed.Seed/ProcessVideoFileUnary',
        request,
        metadata || {},
        this.methodDescriptorProcessVideoFileUnary,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/seed.Seed/ProcessVideoFileUnary',
    request,
    metadata || {},
    this.methodDescriptorProcessVideoFileUnary);
  }

  methodDescriptorGetModelConfig = new grpcWeb.MethodDescriptor(
    '/seed.Seed/GetModelConfig',
    grpcWeb.MethodType.UNARY,
    seed_pb.Request,
    seed_pb.Response,
    (request: seed_pb.Request) => {
      return request.serializeBinary();
    },
    seed_pb.Response.deserializeBinary
  );

  getModelConfig(
    request: seed_pb.Request,
    metadata?: grpcWeb.Metadata | null): Promise<seed_pb.Response>;

  getModelConfig(
    request: seed_pb.Request,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: seed_pb.Response) => void): grpcWeb.ClientReadableStream<seed_pb.Response>;

  getModelConfig(
    request: seed_pb.Request,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: seed_pb.Response) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/seed.Seed/GetModelConfig',
        request,
        metadata || {},
        this.methodDescriptorGetModelConfig,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/seed.Seed/GetModelConfig',
    request,
    metadata || {},
    this.methodDescriptorGetModelConfig);
  }

  methodDescriptorGetModelConfigs = new grpcWeb.MethodDescriptor(
    '/seed.Seed/GetModelConfigs',
    grpcWeb.MethodType.UNARY,
    seed_pb.Empty,
    seed_pb.ModelConfigList,
    (request: seed_pb.Empty) => {
      return request.serializeBinary();
    },
    seed_pb.ModelConfigList.deserializeBinary
  );

  getModelConfigs(
    request: seed_pb.Empty,
    metadata?: grpcWeb.Metadata | null): Promise<seed_pb.ModelConfigList>;

  getModelConfigs(
    request: seed_pb.Empty,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: seed_pb.ModelConfigList) => void): grpcWeb.ClientReadableStream<seed_pb.ModelConfigList>;

  getModelConfigs(
    request: seed_pb.Empty,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: seed_pb.ModelConfigList) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/seed.Seed/GetModelConfigs',
        request,
        metadata || {},
        this.methodDescriptorGetModelConfigs,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/seed.Seed/GetModelConfigs',
    request,
    metadata || {},
    this.methodDescriptorGetModelConfigs);
  }

  methodDescriptorUpdateModelConfigs = new grpcWeb.MethodDescriptor(
    '/seed.Seed/UpdateModelConfigs',
    grpcWeb.MethodType.UNARY,
    seed_pb.ModelConfigList,
    seed_pb.ModelManagementResponse,
    (request: seed_pb.ModelConfigList) => {
      return request.serializeBinary();
    },
    seed_pb.ModelManagementResponse.deserializeBinary
  );

  updateModelConfigs(
    request: seed_pb.ModelConfigList,
    metadata?: grpcWeb.Metadata | null): Promise<seed_pb.ModelManagementResponse>;

  updateModelConfigs(
    request: seed_pb.ModelConfigList,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: seed_pb.ModelManagementResponse) => void): grpcWeb.ClientReadableStream<seed_pb.ModelManagementResponse>;

  updateModelConfigs(
    request: seed_pb.ModelConfigList,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: seed_pb.ModelManagementResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/seed.Seed/UpdateModelConfigs',
        request,
        metadata || {},
        this.methodDescriptorUpdateModelConfigs,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/seed.Seed/UpdateModelConfigs',
    request,
    metadata || {},
    this.methodDescriptorUpdateModelConfigs);
  }

  methodDescriptorAddModelFromS3 = new grpcWeb.MethodDescriptor(
    '/seed.Seed/AddModelFromS3',
    grpcWeb.MethodType.UNARY,
    seed_pb.AddModelRequest,
    seed_pb.ModelManagementResponse,
    (request: seed_pb.AddModelRequest) => {
      return request.serializeBinary();
    },
    seed_pb.ModelManagementResponse.deserializeBinary
  );

  addModelFromS3(
    request: seed_pb.AddModelRequest,
    metadata?: grpcWeb.Metadata | null): Promise<seed_pb.ModelManagementResponse>;

  addModelFromS3(
    request: seed_pb.AddModelRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: seed_pb.ModelManagementResponse) => void): grpcWeb.ClientReadableStream<seed_pb.ModelManagementResponse>;

  addModelFromS3(
    request: seed_pb.AddModelRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: seed_pb.ModelManagementResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/seed.Seed/AddModelFromS3',
        request,
        metadata || {},
        this.methodDescriptorAddModelFromS3,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/seed.Seed/AddModelFromS3',
    request,
    metadata || {},
    this.methodDescriptorAddModelFromS3);
  }

  methodDescriptorHealth = new grpcWeb.MethodDescriptor(
    '/seed.Seed/Health',
    grpcWeb.MethodType.UNARY,
    seed_pb.Empty,
    seed_pb.HealthResponse,
    (request: seed_pb.Empty) => {
      return request.serializeBinary();
    },
    seed_pb.HealthResponse.deserializeBinary
  );

  health(
    request: seed_pb.Empty,
    metadata?: grpcWeb.Metadata | null): Promise<seed_pb.HealthResponse>;

  health(
    request: seed_pb.Empty,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: seed_pb.HealthResponse) => void): grpcWeb.ClientReadableStream<seed_pb.HealthResponse>;

  health(
    request: seed_pb.Empty,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: seed_pb.HealthResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/seed.Seed/Health',
        request,
        metadata || {},
        this.methodDescriptorHealth,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/seed.Seed/Health',
    request,
    metadata || {},
    this.methodDescriptorHealth);
  }

}

